export const siteURL = 'https://api.celectric.rs';
export const baseURL = `${siteURL}/api`;
export const baseApiUrl = `${siteURL}/api/v1/`;
